<template>
  <div class="cta-middle">
    <link-button :link="link" @click="$emit('link')" class="btn1" />
    <div class="text">メールアドレス、パスワード1分で簡単登録</div>
  </div>
</template>

<script>
import LinkButton from '@/utvStore/components/partials/LinkButton'

export default {
  name: 'CtaMiddle',
  components: {
    LinkButton
  },
  props: {
    link: String,
    require: true,
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.cta-middle {
  margin: 12.8% 8% 17.066%;
  .btn1 {
    margin: 0 0 4.776%;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
  }
  .text {
    color: $col_normal_font;
    font-size: unquote('min(4vw, 23px)');
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/CtaMiddle.vue